import styles from './page.module.scss';
import { Header } from './header';
import { Form } from './form';

export const CreateCandidate = () => {
  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.content}>
        <Form />
        <div className={styles.infoConsent}>Достоверность указанной выше информации подтверждаю</div>
      </div>
    </div>
  );
};
